/* GymBase v15: the sign-up popup now submits a REAL Shopify customer (newsletter) form, so the shopper is
   actually subscribed before the WELCOME10 code is shown. WELCOME10 only works for subscribed emails with no
   orders yet, so the code is shown after a successful sign-up (?customer_posted=true). */
class PromoPopup {
  constructor(container) {
    this.container = container;
    this.popupModal = container.querySelector('.sign-up-popup-modal');
    this.overlay = container.querySelector('.sign-up-popup-overlay');
    this.closeButton = this.popupModal.querySelector('.popup-modal__close');
    this.dismissButton = this.popupModal.querySelector('.popup-modal__dismiss-btn');
    this.form = this.popupModal.querySelector('form.newsletter-form');
    this.emailInput = this.form && this.form.querySelector('input[type="email"]');
    this.successModal = container.querySelector('.success-popup-modal');
    this.successOverlay = container.querySelector('.success-popup-overlay');
    this.copyButton = this.successModal && this.successModal.querySelector('.popup-modal__copy-btn');
    this.copySuccessMsg = this.successModal && this.successModal.querySelector('.popup-modal__success-msg');
    this.successCloseButton = this.successModal && this.successModal.querySelector('.popup-modal__close');
    this.successDismissButton = this.successModal && this.successModal.querySelector('.popup-modal__dismiss-btn');
    this.sectionId = this.popupModal.dataset.sectionId;
    this.testMode = this.popupModal.dataset.testMode === 'true';
    this.delaySeconds = parseInt(this.popupModal.dataset.delaySeconds, 10);
    this.delayDays = parseInt(this.popupModal.dataset.delayDays, 10);
    this.storageKey = 'promo-popup-' + window.location.host + '-' + this.sectionId;
    this.subKey = 'promo-bar-subscribed-' + window.location.host;
    this.init();
  }
  get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  init() {
    this.setupEventListeners();
    if (this.form) this.setupFormSubmission();
    var posted = new URLSearchParams(window.location.search).get('customer_posted') === 'true';
    if (posted) {
      this.set(this.subKey, JSON.stringify({ subscribed: true }));
      this.set(this.storageKey, JSON.stringify({ next_display_date: this.farFuture(), dismissed: false }));
      this.showSuccessPopup();
      return;
    }
    if (this.testMode) return;
    if (this.get(this.subKey)) return;
    this.checkAndShowPopup();
  }
  setupEventListeners() {
    this.closeButton.addEventListener('click', () => this.closePopup());
    if (this.dismissButton) this.dismissButton.addEventListener('click', (e) => { e.preventDefault(); this.closePopup(); });
    this.overlay.addEventListener('click', () => this.closePopup());
    if (this.successModal) {
      if (this.copyButton) this.copyButton.addEventListener('click', () => this.handleCopyCode());
      if (this.successCloseButton) this.successCloseButton.addEventListener('click', () => this.closeSuccessPopup());
      if (this.successDismissButton) this.successDismissButton.addEventListener('click', () => this.closeSuccessPopup());
      if (this.successOverlay) this.successOverlay.addEventListener('click', () => this.closeSuccessPopup());
    }
  }
  setupFormSubmission() {
    this.form.addEventListener('submit', (e) => {
      if (!this.emailInput || !this.emailInput.value || !this.emailInput.checkValidity()) { e.preventDefault(); if (this.emailInput) this.emailInput.reportValidity(); return; }
      /* Let the browser submit the real Shopify form: it subscribes the email and reloads with ?customer_posted=true */
      this.set(this.storageKey, JSON.stringify({ next_display_date: this.calculateNextDisplayDate(), dismissed: false }));
    });
  }
  farFuture() { return new Date(Date.now() + 3650 * 24 * 60 * 60 * 1000).toISOString(); }
  calculateNextDisplayDate() { return new Date(Date.now() + this.delayDays * 24 * 60 * 60 * 1000).toISOString(); }
  checkAndShowPopup() {
    var stored = this.get(this.storageKey);
    if (stored) { try { var o = JSON.parse(stored); if (new Date(o.next_display_date) > new Date()) return; } catch (e) {} }
    setTimeout(() => this.showPopup(), this.delaySeconds * 1000);
  }
  showPopup() { this.popupModal.classList.add('popup-modal--active'); this.overlay.classList.add('popup-overlay--active'); }
  closePopup() {
    this.popupModal.classList.remove('popup-modal--active');
    this.overlay.classList.remove('popup-overlay--active');
    if (!this.testMode && !this.get(this.subKey)) this.set(this.storageKey, JSON.stringify({ next_display_date: this.calculateNextDisplayDate(), dismissed: true }));
  }
  showSuccessPopup() {
    if (!this.successModal) return;
    this.popupModal.classList.remove('popup-modal--active');
    this.overlay.classList.remove('popup-overlay--active');
    this.successModal.classList.add('popup-modal--active');
    this.successOverlay.classList.add('popup-overlay--active');
  }
  closeSuccessPopup() {
    if (!this.successModal) return;
    this.successModal.classList.remove('popup-modal--active');
    this.successOverlay.classList.remove('popup-overlay--active');
  }
  handleCopyCode() {
    var input = this.successModal.querySelector('#DiscountCode--' + this.sectionId);
    if (!input) return;
    var done = () => { if (this.copySuccessMsg) { this.copySuccessMsg.style.display = 'block'; setTimeout(() => { this.copySuccessMsg.style.display = 'none'; }, 3000); } };
    if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(input.value).then(done, () => { input.select(); document.execCommand('copy'); done(); }); }
    else { input.select(); document.execCommand('copy'); done(); }
  }
}
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-section-type="newsletter-popup"]').forEach(function (section) {
    new PromoPopup(section.closest('section, .shopify-section'));
  });
});
